<template>
  <div class="location-table fbc-table-header-labels" data-testid="setup-location__table">
    <div class="location-table__datatable-wrap">
      <lb-datatableaction
        ref="dataTableAction"
        :headers="headers"
        :tabledata="tableData"
        :displayed-row-count="rows.length"
        :itemsperpage="itemsPerPage"
        :bulk-actions="false"
        :selectfilter="activeColumnFilters"
        :page_details="pageDetails"
        :loading="loading"
        data-testid="setup-location__datatable"
        header-bg-class="fbc-table-header-bg"
        @filter-item="onFilterItem"
        @filter-active-change="onFilterActiveChange"
        @clear-item="onClearItem"
      >
        <template #tbody>
          <tr
            v-for="item in rows"
            :key="item._id"
            class="location-table__row"
            :class="{ 'location-table__row--disabled': !item.status }"
            data-testid="setup-location__row"
          >
            <template v-for="header in headers">
              <td
                v-if="header.visible && header.value !== 'action' && header.value !== 'ingestion_type'"
                :key="`${header.value}-${item._id}-value`"
                class="px-4 single-line"
                :class="{ 'description-header': header.value === 'description' }"
                data-testid="setup-location__cell"
              >
                <span data-testid="setup-location__cell-value">{{ getCellValue(item, header.value) }}</span>
              </td>

              <td
                v-else-if="header.visible && header.value === 'ingestion_type'"
                :key="`${header.value}-${item._id}-ingestion`"
                class="px-4 single-line"
                data-testid="setup-location__ingestion-cell"
              >
                <span
                  class="location-table__ingestion-badge"
                  :class="{ 'location-table__ingestion-badge--manual': item.ingestion_type === 'Manual' }"
                  data-testid="setup-location__ingestion-value"
                >
                  {{ item.ingestion_type }}
                </span>
              </td>

              <td
                v-else-if="header.visible && header.value === 'action'"
                :key="`${header.value}-${item._id}-action`"
                class="px-0 single-line border-right action-data"
                data-testid="setup-location__action-cell"
              >
                <div class="location-table__action-group">
                  <v-tooltip bottom content-class="tooltip-bottom">
                    <template #activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        :disabled="!canEdit || !item.status"
                        data-testid="setup-location__edit-btn"
                        @click="$emit('edit', item)"
                      >
                        <img src="/img/icons/PenEditIcon.svg" alt="Edit" class="location-table__edit-icon" />
                      </v-btn>
                    </template>
                    <span>Edit</span>
                  </v-tooltip>

                  <activity-log
                    :resource-id="item._id"
                    :row-description="item.name"
                    data-testid="setup-location__activity-log-btn"
                  />

                  <span class="location-table__action-divider" aria-hidden="true" />

                  <v-tooltip bottom content-class="tooltip-bottom">
                    <template #activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <v-switch
                          class="location-table__switch"
                          dense
                          inset
                          hide-details
                          :disabled="!canEdit"
                          :input-value="!!item.status"
                          :data-testid="item.status ? 'setup-location__status-enabled' : 'setup-location__status-disabled'"
                          @change="$emit('toggle-status', { item, enabled: $event })"
                        />
                      </div>
                    </template>
                    <span>{{ item.status ? 'Disable' : 'Enable' }}</span>
                  </v-tooltip>
                </div>
              </td>
            </template>
          </tr>
        </template>
      </lb-datatableaction>
    </div>
  </div>
</template>

<script>
import './LocationTable.scss';
import ActivityLog from '@/modules/financialclose/components/ActivityLog/ActivityLog.vue';
import { ITEMS_PER_PAGE, PAGE_DETAILS, TABLE_HEADERS } from '../../utils/locationConstants';

export default {
  name: 'LocationTable',

  components: {
    ActivityLog,
  },

  props: {
    rows: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    itemsPerPage: {
      type: Number,
      default: ITEMS_PER_PAGE,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
    locationHeaderLabel: {
      type: String,
      default: 'Location',
    },
    pageDetails: {
      type: Object,
      default: () => ({ ...PAGE_DETAILS }),
    },
  },

  data() {
    return {
      activeColumnFilters: {},
      hasActiveFilters: false,
    };
  },

  methods: {
    getCellValue(item, key) {
      return item?.[key] ?? '';
    },

    onFilterItem(filters) {
      this.activeColumnFilters = filters || {};
      this.$emit('filter-change', this.activeColumnFilters);
    },

    onClearItem(filters) {
      this.activeColumnFilters = filters || {};
      this.$emit('filter-change', this.activeColumnFilters);
    },

    onFilterActiveChange(isActive) {
      this.hasActiveFilters = !!isActive;
      this.$emit('filter-active-change', this.hasActiveFilters);
    },

    clearTableFilter() {
      if (this.$refs.dataTableAction) {
        this.$refs.dataTableAction.clearFilter();
      }
    },
  },
};
</script>
